export const DO_SEARCH = 'DO_SEARCH';
export const SEARCH_SELECT_ITEM = 'SEARCH_SELECT_ITEM';
export const CLEAR_SELECT_ITEM = 'CLEAR_SELECT_ITEM';
export const SEARCH_ADD_SUGGESTIONS = 'SEARCH_ADD_SUGGESTIONS';
export const SEARCH_INPUT_CLICKED = 'SEARCH_INPUT_CLICKED';

export const searchText = text => {
  return {
    type: DO_SEARCH,
    text
  };
};

export const searchInputClicked = newState => {
  return {
    type: SEARCH_INPUT_CLICKED,
    data: newState
  };
};

export const clearSearchItem = () => {

  return {
    type: CLEAR_SELECT_ITEM,
  };
};

export const selectSearchItem = (data) => {
  return {
    type: SEARCH_SELECT_ITEM,
    category: data.category,
    index: data.i,
    zooming: (typeof data.zooming !== 'undefined' ? data.zooming : true)
  };
};

export const SEARCH_FULL_RESULT = 'SEARCH_FULL_RESULT';
export const searchFullResult = (data) => {
  return {
    type: SEARCH_FULL_RESULT,
    data
  };
};

export const CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const clearSuggestions = () => {
  return {
    type: CLEAR_SUGGESTIONS
  };
};



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/search/actions.js